export default "__VITE_ASSET__dd6d67e4__"